export default __webpack_public_path__ + "static/media/loginCover.27f4718d.png";